import {
  periodShortcutRange,
  type PeriodShortcut,
} from "@/domain/invoices/datePeriodShortcuts";
import type { InvoiceFilterValues } from "@/domain/invoices/invoiceFilterState";

export function emptyBulkExportFilters(
  period: PeriodShortcut = "last-month",
): InvoiceFilterValues {
  const { dateFrom, dateTo } = periodShortcutRange(period);
  return {
    customerIds: [],
    statuses: [],
    dateFrom,
    dateTo,
    amountMin: "",
    amountMax: "",
    dueDateFrom: "",
    dueDateTo: "",
  };
}

export type { PeriodShortcut };
